module.exports = __webpack_public_path__ + "img/PoliceWarning.bf5a459b.svg";